<script setup lang="ts">
	import {reactive, ref, computed, watch, onMounted} from 'vue';
	import AutocompleteInput from '@/vue/form/AutocompleteInput.vue';
	import {injectEnv} from "@fd/Environment";
	import SymIcon from "@fd/helpers/SymIcon.vue";

	const props = defineProps({
		data: String
	});

	const sourceType = ref(0);
	const campaign = ref(0);
	const campaignName = ref("");
	const folders = ref([{key:"filterCustomers", checked:false, title: "menu.viewParties", icon: "party"},
					{key:"filterOrgs", checked:false, title: "menu.viewOrgs", icon: "org"},
					{key:"filterPeople", checked:false, title: "menu.viewPeople", icon: "individual"},
					{key:"filterBranches", checked:false, title: "menu.viewBranches", icon: "branch"}]);
	const campaignType = ref<string>("NO");	// NO, NEW, EXISTING
	const errorMessage = ref("");
	const env = injectEnv();

	const output = computed(() => {
			let data:any = {
				sourceType: sourceType.value,
				campaign: campaign.value,
				campaignType: campaignType.value,
				campaignName: campaignName.value,
				folders: []
			};
			folders.value.filter((item) => item.checked).forEach((item) => data.folders.push(item.key));
			return JSON.stringify(data);
		});

	function updateInputValue(name: string): void {
		campaignName.value = name;
	}

	watch(sourceType, (newValue) => {
		//reset shared values
		campaign.value=0;
		campaignName.value="";
		campaignType.value="NO";
	});

	watch(campaignType, (newValue) => {
		campaign.value=0;
		campaignName.value="";
	});

	//onCreated
	console.log("data:"+props.data);
	if (!!props.data) {
		const json = JSON.parse(props.data);
		sourceType.value=json.sourceType;
		if (sourceType.value===0) {
			campaignType.value = json.campaignType;
			folders.value.forEach((item) => item.checked=json.folders.includes(item.key));
		}
		campaign.value=json.campaign;
		campaignName.value=json.campaignName;
	}
	
	onMounted(() => {
		if (!!props.data) {
			const json = JSON.parse(props.data);
			campaign.value=json.campaign;
			campaignName.value=json.campaignName;
			//console.log("cam name:"+campaignName.value+" id:"+campaign.value);
		}
	});
	
	
</script>
<template>
	<fieldset>
		<legend class="bulk-source-selector">
			<label><input type="radio" v-model.number="sourceType" :value="0"/> {{ env.msg("menu.viewSubCustomers") }}</label>
			<label><input type="radio" v-model.number="sourceType" :value="1"/> {{ env.msg("form.editCampaign") }}</label>
		</legend>


		<div v-if="sourceType===0" class="bulk-source-parties">
			<div class="bulk-sources">
				<label v-for="folder in folders" class="bulk-source">
					<input type="checkbox" v-model="folder.checked">&nbsp;
					<sym-icon :name="folder.icon"/>
					<span class="tab-label">{{ env.msg(folder.title) }}</span>
				</label>
				<div class="formHelp">{{ env.msg("bulkMail.howCustomers.hint") }}</div>
			</div>
			<div class="bulk-new-campaign">
				<label>{{ env.msg("bulkMail.recipientsToCampaign") }}:</label>
				<select v-model="campaignType">
					<option value="NO">{{ env.msg("bmf.doNotAddToCampaign") }}</option>
					<option value="NEW">{{ env.msg("bmf.createCampaign") }}</option>
					<option value="EXISTING">{{ env.msg("bmf.addToCampaign") }}</option>
				</select>
				<input v-if="campaignType === 'NEW'" type="text" v-model="campaignName" size="32" maxlength="32" :placeholder="env.msg('campaign.symbol').toLowerCase()">
				<autocomplete-input v-else-if="campaignType === 'EXISTING'" rest-api="./api/campaigns/suggest" v-model.number="campaign" @updateInputValue="updateInputValue"
									:size="32" :tabindex="10" name="campaignName" :value="campaignName" :suggest-empty="true"/>
			</div>
		</div>
		<div v-else class="bulk-source-campaign">
			<label>{{ env.msg("bmf.chooseCampaign") }}:</label>
			<autocomplete-input rest-api="./api/campaigns/suggest" v-model.number="campaign" @updateInputValue="updateInputValue"
				:size="32" :tabindex="10" :value="campaignName" :suggest-empty="true"/>
		</div>
		<input type="hidden" name="bulkConfigData" :value="output"/>
	</fieldset>
</template>
<style>
.bulk-source-selector {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	column-gap: 32px;
}
.bulk-sources,
.bulk-new-campaign {
	display: flex;
	flex-direction: column;
	row-gap: 4px;
}
.bulk-source-parties,
.bulk-source-campaign {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	column-gap: 16px;
}
.bulk-source-campaign {
	padding-bottom: 8px;
}
</style>